import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Menu, Input, Label } from 'semantic-ui-react';
import * as API from '../../API';
export const CtaMuniMenu = ({ className, title, items, listRole, search, emptyListNotice, emptySearchNotice, onAdd, onRemove }) => {
    const [searchPhrase, setSearchPhrase] = useState('');
    const [municipalityDict, setMunicipalityDict] = useState(null);
    const { data: codeListData } = useQuery('kb/kodeliste', () => API.fetchCodeList());
    useEffect(() => {
        if (codeListData) {
            setMunicipalityDict(codeListData.kommuner);
        }
    }, [codeListData]);
    const filtered = items.filter(knr => {
        var _a, _b;
        return (`${knr} ${(_b = ((_a = codeListData === null || codeListData === void 0 ? void 0 : codeListData.kommuner) !== null && _a !== void 0 ? _a : {})[knr]) !== null && _b !== void 0 ? _b : ''}`).toLocaleLowerCase('nb').includes(searchPhrase.trim().toLocaleLowerCase('nb'));
    });
    const onSearchKeyDown = (e) => {
        if (e.key !== 'Enter' || e.nativeEvent.isComposing)
            return;
        e.preventDefault();
        if (e.repeat ||
            listRole !== 'source' ||
            !searchPhrase.trim() ||
            filtered.length !== 1 ||
            !onAdd)
            return;
        const knr = filtered[0];
        onAdd(knr);
        setSearchPhrase('');
    };
    const onCLickLabel = (e, data) => {
        var _a, _b, _c;
        const itemText = (_b = (_a = e.currentTarget.closest('.item')) === null || _a === void 0 ? void 0 : _a.querySelector('.item-text')) === null || _b === void 0 ? void 0 : _b.textContent;
        if (!itemText)
            return;
        const knr = (_c = /^(\d{4}) .+$/.exec(itemText)) === null || _c === void 0 ? void 0 : _c[1];
        if (!knr)
            return;
        if (listRole === 'source') {
            onAdd === null || onAdd === void 0 ? void 0 : onAdd(knr);
        }
        else {
            onRemove === null || onRemove === void 0 ? void 0 : onRemove(knr);
        }
    };
    const headerContent = search
        ? _jsx(Menu.Item, { className: "list-search", children: _jsx(Input, { fluid: true, icon: "search", placeholder: "S\u00F8k etter kommune", value: searchPhrase, onChange: (_, data) => setSearchPhrase(data.value), onKeyDown: onSearchKeyDown }) })
        : _jsx(Menu.Item, { className: "list-title", children: _jsx("div", { children: title !== null && title !== void 0 ? title : '' }) });
    const clsx = [
        `cta-muni-menu ${listRole}-list`,
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    const noticeOnEmptyList = items.length === 0
        ? _jsx(Menu.Item, { className: "user-notification", children: emptyListNotice !== null && emptyListNotice !== void 0 ? emptyListNotice : 'Listen er tom' })
        : filtered.length === 0
            ? _jsx(Menu.Item, { className: "user-notification", children: emptySearchNotice !== null && emptySearchNotice !== void 0 ? emptySearchNotice : 'Ingen treff' })
            : null;
    return (_jsx("div", { className: clsx, children: _jsxs(Menu, { vertical: true, fluid: true, children: [headerContent, filtered.map(knr => (_jsxs(Menu.Item, { children: [_jsx("span", { className: "item-text", children: `${knr} ${municipalityDict === null || municipalityDict === void 0 ? void 0 : municipalityDict[knr]}` }), " ", _jsx(Label, { onClick: onCLickLabel, children: listRole === 'source' ? 'Legg til' : 'Fjern' })] }, knr))), noticeOnEmptyList] }) }));
};
